<template>
    <div class="bg-login-fuzzy">
        <x-card fill-height fill-width class="policy">
            <x-card-title class="justify-center">
                <h1>Welcome to TepfinX</h1>
            </x-card-title>

            <x-card-text>
                <p>
                    You are about to enter a live trading platform - tepfinx.com, that offers the User the ability
                    to source price and bind political risk & structured credit insurance. By proceeding, you acknowledge that you are aware of the above statement.
                </p>
                <br>
                <p>
                    The site is owned and operated by Howden Insurance Brokers Limited.
                </p>
            </x-card-text>
            <x-card-actions>

                <x-btn color="tertiary" small @click="logout">Cancel</x-btn>

                <x-spacer/>

                <x-btn color="primary" small @click="goToDashboard">Accept</x-btn>
            </x-card-actions>
        </x-card>
    </div>
</template>
<script>
    export default {
        name: "PolicyWarning",

        methods: {
            // Go to correct dashboard based on access
            async goToDashboard() {
                await this.$root.loadData();

                if (['insurer', 'captive_insurer'].includes(this.$root.user.company.company_type)) {
                    this.$router.push({ name: 'insurer-dashboard' });
                } else {
                    this.$router.push({ name: 'broker-dashboard' });
                }
            },
            logout() {
                sessionStorage.removeItem('tx-dashboard-filters');
                this.$hyperionAuth.logout();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .bg-login-fuzzy {
        position: relative;
        width:100%;
        height:100%;
        background-image: url('/assets/img/BG_SHIP_X.jpg');
        background-size: cover;
        background-position: center center;
        overflow-y: auto;
        display: flex;
        justify-content: center;
        align-items: center;

        .policy {
            text-align: center;
            border-radius: 8px;
            max-width: 568px;
            margin: 0 auto;
            @include card-gradient;

            h1 {
                font-family: $font-title;
                font-size: rem(24px);
                color: #FFFFFF;
                line-height: 1em;
            }

            p {
                font-size: 14px;
                color: #FFFFFF;
                line-height: 24px;
            }

            .accept {
                padding: 0 40px;
                height: 50px;
                border-radius: 4px;
                background-color: #54c7ea !important;
                font-size: 16px;
                color: #283648;
            }
            .cancel {
                padding: 0 40px;
                height: 50px;
                border-radius: 4px;
                background-color: #cfcfd7 !important;
                font-size: 16px;
                color: #283648;
                border: 1px solid rgba(154,160,176,0.4);
            }
        }
    }
</style>
